import { useEffect } from 'react';
import { usePreview } from '../lib/contexts/PreviewContext';
import { setPreviewCookie } from '../lib/utils/previewUtils';

/**
 * PreviewStateSyncer component
 * Synchronizes localStorage preview state with cookies for SSR compatibility
 * This component should be included in _app.tsx to ensure sync happens on every page
 */
const PreviewStateSyncer = () => {
  const { isPreviewMode } = usePreview();

  useEffect(() => {
    // Sync localStorage state with cookies for SSR
    setPreviewCookie(isPreviewMode);
  }, [isPreviewMode]);

  // This component renders nothing - it's just for side effects
  return null;
};

export default PreviewStateSyncer;
